import React from 'react';
import { useAuth } from '../../auth/AuthProvider';
import { useTheme } from '../../theme/ThemeProvider';
import HelpButton from '../help/HelpButton';

function Row({ label, value }) {
  return (
    <div className="flex justify-between items-center py-2 border-b border-surface-border dark:border-surface-dark-border last:border-0">
      <span className="text-sm text-surface-muted dark:text-surface-dark-muted">{label}</span>
      <span className="text-sm font-medium">{value}</span>
    </div>
  );
}

export default function AccountPage() {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();

  return (
    <div className="p-8 max-w-2xl">
      <div className="flex items-center justify-between mb-1">
        <h1 className="text-xl font-semibold">Account</h1>
        <HelpButton moduleKey="account" />
      </div>
      <p className="text-sm text-surface-muted dark:text-surface-dark-muted mb-6">
        Profile, security, and appearance settings.
      </p>

      <section className="rounded-thin bg-surface-panel dark:bg-surface-dark-panel border border-surface-border dark:border-surface-dark-border p-5 mb-5 shadow-thin">
        <h2 className="text-sm font-semibold mb-3">Profile</h2>
        <Row label="Name"      value={user?.name} />
        <Row label="Email"     value={user?.email} />
        <Row label="Role"      value={<span className="capitalize">{user?.role}</span>} />
        {user?.extension && <Row label="Extension" value={user.extension} />}
        <Row label="Status"    value={<span className="capitalize">{user?.status}</span>} />
        <Row label="MFA"       value={user?.mfa_enrolled ? '✅ Enabled' : '⚠️ Not enrolled'} />
      </section>

      <section className="rounded-thin bg-surface-panel dark:bg-surface-dark-panel border border-surface-border dark:border-surface-dark-border p-5 mb-5 shadow-thin">
        <h2 className="text-sm font-semibold mb-3">Appearance</h2>
        <div className="flex gap-2">
          {['light', 'dark'].map((opt) => (
            <button
              key={opt}
              onClick={() => setTheme(opt)}
              className={
                'px-4 py-2 rounded-thin border text-sm capitalize transition-colors ' +
                (theme === opt
                  ? 'bg-continuum-500 text-white border-continuum-500'
                  : 'border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle')
              }
            >
              {opt === 'light' ? '☀️' : '🌙'} {opt}
            </button>
          ))}
        </div>
        <p className="mt-2 text-xs text-surface-muted dark:text-surface-dark-muted">
          Preference is saved in your browser. (Server-side sync coming in Phase 1.)
        </p>
      </section>

      <section className="rounded-thin bg-surface-panel dark:bg-surface-dark-panel border border-surface-border dark:border-surface-dark-border p-5 shadow-thin">
        <h2 className="text-sm font-semibold mb-3">Session</h2>
        <button
          onClick={logout}
          className="px-4 py-2 rounded-thin border border-surface-border dark:border-surface-dark-border text-sm hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle"
        >
          Sign out
        </button>
      </section>
    </div>
  );
}
